import {Player} from "@alphabatem/js_sdk/src/entities/player";
import * as THREE from "three";
import {Webcam} from "./webcam";
import Animatable from "./animatable";
import {CSS2DObject} from 'three/examples/jsm/renderers/CSS2DRenderer.js';
import * as SkeletonUtils from 'three/examples/jsm/utils/SkeletonUtils.js';


export class ThreePlayer extends Player {

	obj = null;

	chatbox = null;
	chatTimeout = null;

	extensions = [];

	animator = new Animatable();

	bodyHeight = 2.7;

	nameLabel = null;

	custom_sprite = ""

	name = ""

	token_address = ""

	//Object
	//  Sprite
	//  Chatbox
	//  Camera Positions (1st, 3rd)
	//  RTC Area

	constructor(uid, modelKey, isLocal, deviceType) {
		super(uid, deviceType, isLocal);
		this.setModelKey(modelKey);
	}

	update() {
		super.update()
		for (let i = 0; i < this.extensions.length; i++) {
			this.extensions[i].update();
		}
	}

	walk(data) {
		super.walk(data)

		//TODO start animation
		if (this.canAnimate()) {
			this.animator.play("walk")
		}

		if (this.local) {
			//TODO Set position marker
		}
	}

	setTokenAddress(address) {
		this.token_address = address
	}

	getTokenAddress() {
		return this.token_address
	}

	setCustomSprite(customSprite) {
		this.custom_sprite = customSprite;
	}

	getUsername() {
		return this.name;
	}

	setUsername(username) {
		this.name = username;
	}

	isAnimating() {
		return this.animator.isCurrentlyPlaying()
	}

	getCurrentAnimation() {
		return this.animator.currentlyPlaying;
	}

	isPlayingAnimations(...animations) {
		return this.animator.isPlaying(...animations)
	}

	playAnimation(key, loop = true) {
		this.animator.play(key, loop)
	}

	stopAllAnimations() {
		this.animator.stopAll()
	}

	stopAnimation(key = null) {
		this.animator.stop(key)
	}

	animate(delta) {
		super.animate(delta);
		this.animator.animate(delta)
	}

	add(modelMgr, scene, callback) {
		if (this.obj !== null)
			return false //Already added

		if (this.custom_sprite !== "") {
			return this._addCustom(modelMgr, scene, callback)
		}

		return this._addDefault(modelMgr, scene, callback);
	}

	_addDefault(modelMgr, scene, callback) {
		const lm = modelMgr.getLoadedModel(this.getModelKey())
		if (lm === null || lm === undefined) {
			console.error("Player::Missing model: ", this.getModelKey())
			return false
		}
		// console.log(`ThreePlayer::addDefault ${this.getModelKey()} - model: `, lm)

		return this._add(modelMgr, scene, lm, callback)
	}

	_addCustom(modelMgr, scene, callback) {
		modelMgr.addModel(this.getModelKey(), this.custom_sprite, () => {
			this._addDefault(modelMgr, scene, callback) //Once loaded then call add
		})
	}

    playerInfo = null

	_add(modelMgr, scene, lm, callback) {
		this.obj = new THREE.Group()
		this.obj.name = this.uid

		let m = SkeletonUtils.clone(lm.getModel()) //We dont clone as it messes with skinned meshes & animations
		m.name = "sprite"
		// m.scale.set(this.scale[0], this.scale[1], this.scale[2])

		// this.scale = m.scale.clone()
		// m.position.y =-this.bodyHeight /2


		const bindings = modelMgr.getModelAnimationBindings(this.getModelKey()) //Gets any animation bindings overrides
		// console.log(`Animation bindings (${this.getModelKey()}):`, JSON.stringify(bindings))

		// console.log(`ThreePlayer::add - animations: ${this.getModelKey()}`, lm.getAnimations(), bindings)
		this.animator.buildAnimations(m.children[0], lm.getAnimations(), bindings)

		this.playAnimation("idle")

		//Chatbox ovehead
		this.chatbox = new THREE.Object3D()
		this.chatbox.name = "chatbox"
		//TODO

		this.playerInfo = new THREE.Object3D()
		this.playerInfo.name = "info"
		this.playerInfo.layers.enableAll()

		//TODO
		// const bbox = new THREE.Box3().setFromObject(m);
		// const center = bbox.getCenter( new THREE.Vector3() );
		// console.log("Player top: ", bbox.max.y)

		// playerInfo.position.x += ( playerInfo.position.x - center.x );
		// playerInfo.position.y = bbox.max.y;
		// playerInfo.position.z += ( playerInfo.position.z - center.z );

		// if (!this.local) {
		// 	const name = document.createElement('div');
		// 	name.className = 'player-name-label';
		// 	name.id = `player-name-label-${this.uid}`
		// 	name.textContent = this.name ? this.name : `Guest-${this.uid.substr(-6)}`;
		// 	this.nameLabel = new CSS2DObject(name);
		// 	this.nameLabel.position.set(0, -0.3, 0);
		// 	playerInfo.add(this.nameLabel);
		// 	this.nameLabel.layers.set(0);
		// 	console.debug("Player label added", this.nameLabel)
		// }


		//WebRTC Video/Audio area
		const webRTCArea = new THREE.Group()
		webRTCArea.name = "web_rtc"


		this.obj.userData.alphaID = this.uid
		this.obj.userData.is_local = this.local
		this.obj.userData.token_addr = this.getTokenAddress()


		// console.debug("Adding player model: ", m)
		this.obj.attach(m)

		// m.position.set(0,-0.5,-0.5)

		this.obj.add(this.chatbox)
		this.obj.add(this.playerInfo)
		this.obj.add(webRTCArea)
		// this.obj.add(new THREE.BoxHelper(m, 0xffff00))

		scene.add(this.obj)

		if (callback !== null)
			callback()
		return true
	}

    addLabel() {
        if (this.nameLabel || this.local || !this.playerInfo) return

        const name = document.createElement('div');
        name.className = 'player-name-label';
        name.id = `player-name-label-${this.uid}`
        name.textContent = this.name ? this.name : `Guest-${this.uid.substr(-6)}`;

        this.nameLabel = new CSS2DObject(name);
        this.nameLabel.position.set(0, -0.3, 0);
        this.nameLabel.layers.set(0);

        this.playerInfo.add(this.nameLabel);
        console.debug("Player label added", this.nameLabel)
    }

    removeLabel() {
        if(!this.nameLabel) return

        this.playerInfo.remove(this.nameLabel)
        this.nameLabel = null
    }

	remove() {
		super.remove()

		if (this.nameLabel !== null)
			this.nameLabel.remove()

		const label = document.getElementById(`player-name-label-${this.uid}`)
		if (label !== null)
			label.remove()
	}

	setVideo(videoElem) {
		console.log("adding camera stream")
		const wc = new Webcam(videoElem)
		this.extensions.push(wc)

		this.obj.children.forEach(child => {
			if (child.name === "web_rtc") {
				wc.add(child)
				return
			}
		})
	}

	onChat(data) {
		console.log("onChat", data)
		super.onChat(data)
		//TODO


		// const canvas = document.createElement('canvas');
		// const spritey = this.makeTextSprite(canvas, data,
		//     {
		//         fontsize: 32,
		//         borderColor: {r: 0, g: 0, b: 0, a: 1.0},
		//         backgroundColor: {r: 255, g: 255, b: 255, a: 0.8}
		//     });
		//
		// this.chatbox.add(spritey);
		//
		// const labelBaseScale = 0.01;
		// spritey.position.y += this.bodyHeight * 1.1;
		//
		// spritey.scale.x = canvas.width * labelBaseScale;
		// spritey.scale.y = canvas.height * labelBaseScale;
		//
		// clearTimeout(this.chatTimeout)
		// this.chatTimeout = setTimeout(() => {
		//     this.chatbox.remove(spritey);
		// }, 7000);

	}

	makeTextSprite(canvas, message, parameters) {
		if (parameters === undefined) parameters = {};

		const fontface = parameters.hasOwnProperty("fontface") ?
			parameters["fontface"] : "Arial";

		const fontsize = parameters.hasOwnProperty("fontsize") ?
			parameters["fontsize"] : 18;

		const borderThickness = parameters.hasOwnProperty("borderThickness") ?
			parameters["borderThickness"] : 4;

		const borderColor = parameters.hasOwnProperty("borderColor") ?
			parameters["borderColor"] : {r: 0, g: 0, b: 0, a: 1.0};

		const backgroundColor = parameters.hasOwnProperty("backgroundColor") ?
			parameters["backgroundColor"] : {r: 255, g: 255, b: 255, a: 1.0};


		const context = canvas.getContext('2d');
		context.font = "Bold " + fontsize + "px " + fontface;
		context.textBaseline = "middle";
		context.textAlign = "center"

		// get size data (height depends only on font size)
		const metrics = context.measureText(message);
		const textWidth = metrics.width;

		// background color
		context.fillStyle = "rgba(" + backgroundColor.r + "," + backgroundColor.g + ","
			+ backgroundColor.b + "," + backgroundColor.a + ")";
		// border color
		context.strokeStyle = "rgba(" + borderColor.r + "," + borderColor.g + ","
			+ borderColor.b + "," + borderColor.a + ")";

		context.lineWidth = borderThickness;
		this.roundRect(context, borderThickness / 2, borderThickness / 2, textWidth + borderThickness, fontsize * 1.4 + borderThickness, 6);
		// 1.4 is extra height factor for text below baseline: g,j,p,q.

		// text color
		context.fillStyle = "rgba(0, 0, 0, 1.0)";

		context.fillText(message, borderThickness, fontsize + borderThickness);

		// canvas contents will be used for a texture
		const texture = new THREE.CanvasTexture(canvas);
		texture.minFilter = THREE.LinearFilter;
		texture.wrapS = THREE.ClampToEdgeWrapping;
		texture.wrapT = THREE.ClampToEdgeWrapping;

		const spriteMaterial = new THREE.SpriteMaterial({map: texture, transparent: true});

		return new THREE.Sprite(spriteMaterial);
	}

// function for drawing rounded rectangles
	roundRect(ctx, x, y, w, h, r) {
		ctx.beginPath();
		ctx.moveTo(x + r, y);
		ctx.lineTo(x + w - r, y);
		ctx.quadraticCurveTo(x + w, y, x + w, y + r);
		ctx.lineTo(x + w, y + h - r);
		ctx.quadraticCurveTo(x + w, y + h, x + w - r, y + h);
		ctx.lineTo(x + r, y + h);
		ctx.quadraticCurveTo(x, y + h, x, y + h - r);
		ctx.lineTo(x, y + r);
		ctx.quadraticCurveTo(x, y, x + r, y);
		ctx.closePath();
		ctx.fill();
		ctx.stroke();
	}
}
